import { useRef, useEffect} from 'react';

function App(props) {

  var editingClass = props.editingClass;
  var allStyles1 = props.allStyles1;
  var clickNavItem = props.clickNavItem;
  var actHoveringWhere = props.actHoveringWhere;
  var doAScreenRef = props.doAScreenRef;
  var itemPath = props.itemPath;
  var anItemKey = props.anItemKey;

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, itemPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var src1 = allStyles1.src;
  if (src1.e){
    src1 = '';
  }

  if (allStyles1.wh){
    delete allStyles1.width;
  }else{
    delete allStyles1.height;
  }


  return <img ref={ref1} className={'img-fluid' + editingClass} style={allStyles1} src={src1} alt='nav' onClick={clickNavItem(anItemKey)} onMouseOver={actHoveringWhere(itemPath.join(' '))} onMouseOut={actHoveringWhere('')}/>

}

export default App;